import { registerTour } from "../tourRegistry";
import { TIER_DISPLAY_NAMES } from "../../config/entitlements";

function getSteps() {
  const totalSteps = 4;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'integrations-overview',
      title: `Integrations Hub <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Connect T3 Books to external services to automate data imports. Each integration syncs data directly into your books, saving manual entry time.',
      attachTo: { element: '[data-tour="integrations-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'integrations-connected',
      title: `Connected Integrations <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Green status indicators show connected integrations. Click any connected integration to manage its settings, view sync status, or disconnect it.',
      attachTo: { element: '[data-tour="integrations-connected"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'integrations-available',
      title: `Available Integrations <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: `Browse integrations you haven't connected yet. Some require a ${TIER_DISPLAY_NAMES.plus} subscription (shown with an upgrade badge). 'Coming Soon' items are in development.`,
      attachTo: { element: '[data-tour="integrations-available"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'integrations-how-it-works',
      title: `How Integrations Work <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'When you connect an integration, it imports data automatically. Bank connections (Plaid) import transactions. Donation sources (Pushpay) import donations. Expense cards (Bill.com, PEX) import card charges. Each integration has its own mapping and sync settings.',
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'integrations',
  pathPattern: '/foundation/integrations',
  getSteps,
  label: 'Integrations Tour',
});
